export const getPurchaseAvailableCredits = (purchase) =>
  Number(
    purchase?.available ??
    purchase?.credits_remaining ??
    Math.max(Number(purchase?.credits_total || 0) - Number(purchase?.credits_used || 0), 0)
  ) || 0;

export const formatPurchaseDate = (purchase) => {
  const rawDate = purchase?.purchased_at || purchase?.created_at || purchase?.updated_at;
  if (!rawDate) return "unknown date";
  const date = new Date(rawDate);
  if (Number.isNaN(date.getTime())) return "unknown date";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatManualPurchaseOption = (purchase) => {
  const player =
    purchase?.player_full_name ||
    purchase?.player_name ||
    `Player ${purchase?.player_id || "-"}`;
  const coach =
    purchase?.coach_full_name ||
    purchase?.coach_name ||
    `Coach ${purchase?.coach_id || "-"}`;
  const packageName =
    purchase?.package_name ||
    purchase?.package_title ||
    `Package ${purchase?.coach_package_id || "-"}`;
  const playerEmail = purchase?.player_email ? ` · ${purchase.player_email}` : "";

  return `#${purchase?.id} · ${formatPurchaseDate(purchase)} · ${player}${playerEmail} · ${coach} · ${packageName} · ${getPurchaseAvailableCredits(purchase)} available`;
};

export const filterManualPurchaseOptions = (
  purchases,
  search,
  selectedPurchaseId = ""
) => {
  const query = search.trim().toLowerCase();
  if (!query) {
    return purchases;
  }

  const selectedId = String(selectedPurchaseId || "");
  const matches = purchases.filter((purchase) => {
    if (selectedId && String(purchase?.id) === selectedId) {
      return true;
    }

    const searchableText = [
      purchase?.id,
      purchase?.player_id,
      purchase?.user_id,
      purchase?.player_full_name,
      purchase?.player_name,
      purchase?.player_email,
      purchase?.coach_id,
      purchase?.coach_full_name,
      purchase?.coach_name,
      purchase?.coach_email,
      purchase?.coach_package_id,
      purchase?.package_id,
      purchase?.package_name,
      purchase?.package_title,
      purchase?.purchased_at,
      purchase?.created_at,
      purchase?.updated_at,
      formatPurchaseDate(purchase),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchableText.includes(query);
  });

  return matches;
};
